import type DialogOptions from '@123/druid/dist/Components/Window/Dialog/DialogOptions';
import type {LangVarTypes} from '@Component/Dialog/Message/Type/LangVarTypes';
import type {AddProductResponse} from '@Component/ShoppingCart/Type/ShoppingCartResponse';
import type {EcommerceData} from '@Service/LegacyBridge/Measure/EcommerceData';
import type {CartItem} from '@Service/LegacyBridge/ShoppingCart/ShoppingCart';

interface EventHubEvents {
    ShoppingCartUpdated: {items: CartItem[]; ecommerceData?: EcommerceData};
    ShoppingCartAdded: CartItem[];
    ShoppingCartDOMUpdated: HTMLElement;
    ProductInViewport: HTMLElement;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'MessageDialog.Open': {options: DialogOptions; type: LangVarTypes; icon: string};
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Bargains.hasRendered': {
        context: HTMLElement;
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'OrderPopup.Opened': void;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Product.rendered': HTMLElement;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'SidePanel.Open': void;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'View.ViewUpdated': HTMLElement | void;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Paginator.Changed': {
        page: string;
        pages: string;
    };
    ShoppingCartProductAdded: {
        event: null;
        response: AddProductResponse;
    };
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Product.added-to-cart.no-recommendation': void;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Product.added-to-cart': void;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'ResultList.Updated': void;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'Search.SearchUpdated': void;
}

declare global {
    interface Window {
        EventHub: {
            instance: {
                on<T extends keyof EventHubEvents>(eventName: T, callback: (data: EventHubEvents[T]) => void): void;
                trigger<T extends keyof EventHubEvents>(eventName: T, args?: EventHubEvents[T]): void;
            };
        };
    }
}

const eventHub = window.EventHub;

export default eventHub;
